module.exports = __webpack_public_path__ + "img/facebook-icon-bg.c6f8a58306806889ab4fa11b941f4cb0.svg";